<!--
 * @Author: your name
 * @Date: 2021-01-12 16:28:22
 * @LastEditTime: 2021-03-08 15:57:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\BackDialog.vue
-->
<template>
  <div id='backDialog'>
    <el-dialog :title="titleName" :visible.sync="refuseVisible" width="26%" custom-class="refuseVisible">
      <template v-if="step==1">
        <span class="refuseBtn" type="primary" @click="backCommon">退回公共任务池</span>
        <span class="refuseBtn" type="primary" @click="trustOther">委托指定人</span>
      </template>
      <template v-if="step==2">
        <el-input placeholder="请输入姓名" v-model="adminParams.userName" class="peopleInput" @change="getQueryUserList">
          <img slot="prefix" src="@/assets/img/search.png" alt="">
        </el-input>
        <el-divider></el-divider>
        <h3>委托指定人</h3>
        <el-scrollbar class="sidebar" view-class="view-box" view-style="height:100%;" :native="false">
          <el-row class="content">
            <div class="selectOne" :class="{activeOne:active==index}" v-for="(item,index) in adminData" :key="index" @click="selectOne(index,item.userName)">{{item.userName}}
              <i class="el-icon-check" v-if="active==index"></i>
            </div>
          </el-row>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
          <span class=" button lastStep" type="primary" @click="lastStep">上一步</span>
          <span class=" button add" type="primary" @click="nextStep">下一步</span>
        </span>
      </template>
      <template v-if="step==3">
        <el-form :model="receiveParams" :rules="receiveParamsRules" ref="otherForm" label-width="100px" class="otherForm">
          <el-form-item label="委托人" v-if="titleName=='委托指定人'">
            {{receiveParams.userName}}
          </el-form-item>
          <el-form-item label="退回原因" prop="returnReason">
            <el-input type="textarea" placeholder="请填写退回原因" v-model="receiveParams.returnReason"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <span class=" button lastStep" type="primary" @click="lastTwoStep">上一步</span>
          <span class=" button add" type="primary" @click="receiveSure">确 定</span>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { taskManagement, queryUserList } from '@/api/index'
export default {
  data() {
    return {
      titleName: "",
      refuseVisible: false,
      step: 1,
      adminParams: {
        userName: "",
      },
      adminData: [],
      active: 0,
      receiveParams: {
        id: '',
        taskStatus: '',
        userName: "",
        returnReason: ""
      },
      receiveParamsRules: {
        returnReason: [{ required: true, message: '请输入退回原因', trigger: 'blur' }]
      },
    }
  },
  created() { },
  methods: {
    backCommon() {
      this.receiveParams.taskStatus = 1
      this.step = 3
      this.titleName = "退回公共任务池"
    },
    async trustOther() {
      this.receiveParams.taskStatus = 2
      this.titleName = '人员分配'
      this.step = 2
      this.getQueryUserList()
    },
    async getQueryUserList() {
      const { data } = await queryUserList(this.adminParams)
      if (data.code != 0) return
      this.adminData = JSON.parse(JSON.stringify(data.userList))
    },
    selectOne(index, name) {
      this.active = index
      this.receiveParams.userName = name
    },
    lastStep() {
      this.step = 1
      this.titleName = '任务退回'
    },
    nextStep() {
      this.step = 3
      this.titleName = '委托指定人'
      if (this.receiveParams.userName == "") {
        this.receiveParams.userName = this.adminData[0].userName
      }
    },
    lastTwoStep() {
      if (this.titleName == '退回公共任务池') {
        this.step = 1
        this.titleName = '任务退回'
      } else if (this.titleName == '委托指定人') {
        this.step = 2
        this.titleName = '人员分配'
      }
    },
    receiveSure() {
      this.$refs.otherForm.validate(async valid => {
        if (valid) {
          const { data } = await taskManagement(this.receiveParams)
          if (data.code != 0) return
          this.refuseVisible = false
          this.receiveParams.returnReason = ''
          this.$parent.$parent.tabIndex = 0
          this.$parent.$parent.findAllTask()
        }
      })
    },
  }
}
</script>
<style lang='less' scoped>
#backDialog {
  /deep/.refuseVisible {
    .el-dialog__body {
      text-align: center;
    }
    .refuseBtn {
      display: inline-block;
      width: 120px;
      height: 36px;
      background-color: #0e6fd0;
      border-radius: 18px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
    }
    .refuseBtn:nth-child(1) {
      margin-right: 30px;
    }
    .refuseBtn:nth-child(2) {
      margin-left: 30px;
    }
    .peopleInput {
      position: relative;
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 10px;
      }
    }
    .peopleInput.el-input--prefix .el-input__inner {
      padding-left: 55px;
    }
    .peopleInput::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 9%;
      transform: translateY(-50%);
      display: inline-block;
      width: 1px;
      height: 18px;
      background-color: #e6eaed;
    }
    .el-divider--horizontal {
      margin: 10px 0;
    }
    h3 {
      text-align: left;
    }
    .content {
      width: 100%;
      max-height: 200px;
      // background-color: #f3f7fa;
      border-radius: 3px;

      .selectOne {
        position: relative;
        width: 100%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        text-align: left;
        cursor: pointer;
        .el-icon-check:before {
          position: absolute;
          top: 50%;
          right: 12%;
          transform: translateY(-50%);
          color: #2879dc;
          font-size: 18px;
          font-weight: 650;
        }
      }
      .activeOne {
        color: #2879dc;
        font-weight: 650;
      }
    }
    .sidebar {
      margin-top: 10px;
      max-height: 250px;
      background-color: #f3f7fa;
    }
    .el-scrollbar__bar.is-horizontal {
      width: 0;
      height: 0;
    }
    .el-scrollbar__thumb {
      background-color: #2879dc;
    }
    .otherForm {
      .el-form-item__content {
        text-align: left;
      }
      .el-form-item__label {
        padding-right: 25px;
      }
      .el-textarea__inner {
        background: #fff;
      }
    }
    .lastStep {
      margin-right: 20px;
    }
  }
}
</style>
